module.exports = __webpack_public_path__ + "img/4. icon family (1).bd190bcf.png";